import { useTranslation } from 'react-i18next';
import { Seo } from '../components/Seo';

const APPLICATIONS = [
  { icon: '🛩️', key: 'uav' },
  { icon: '🚗', key: 'autonomous' },
  { icon: '⛽', key: 'oilGas' },
  { icon: '🏗️', key: 'tunnel' },
  { icon: '🛡️', key: 'defense' },
  { icon: '🔬', key: 'research' }
];

export function Applications() {
  const { t } = useTranslation();

  return (
    <>
      <Seo
        title="Applications & Industries | GyroNavi"
        description="GyroNavi inertial sensors power critical systems across UAV, autonomous driving, oil & gas, tunnel mapping, defense, and research applications."
        path="/applications"
      />
      <section className="section">
        <p className="eyebrow">{t('applications:page.eyebrow')}</p>
        <h1 className="mt-2 text-4xl font-black text-ink">{t('applications:page.title')}</h1>
        <p className="mt-3 text-slate-600">{t('applications:page.subtitle')}</p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {APPLICATIONS.map((app) => (
            <article key={app.key} className="flex items-start gap-4 rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
              <div className="text-3xl">{app.icon}</div>
              <div>
                <h2 className="font-bold text-ink">{t(`applications:items.${app.key}.title`)}</h2>
                <p className="mt-1 text-sm leading-6 text-slate-600">{t(`applications:items.${app.key}.text`)}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
